import { metricPropsSchema } from '../component-catalog.js';
export const metricDefinition = {
    type: 'Metric',
    category: 'content',
    propsSchema: metricPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'KPI / single-value display with optional trend. Props: value (required), label?, trend?, trendDirection? ("up" | "down" | "flat"), trendSentiment? ("positive" | "negative" | "neutral", overrides default color when direction and sentiment diverge — e.g., weight going down is positive).',
};
//# sourceMappingURL=Metric.js.map